import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';
import { INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BACKTEST_ANNUALIZED_BUCKETED_RETURN,
    title: 'Annualized Returns by Bucket',
    helpLabel: 'k8xpw13s',
    form: true,
    defaultParams: {
      isBasket: false,
      statistics_type: 'return',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),

    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BACKTEST],
    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BACKTEST_ANNUALIZED_BUCKETED_RISK,
    title: 'Annualized Risk by Bucket',
    helpLabel: 'z2mvhs99',
    form: true,
    defaultParams: {
      isBasket: false,
      statistics_type: 'risk',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),

    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BACKTEST],
    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BACKTEST_ANNUALIZED_BUCKETED_ADJUSTED,
    title: 'Annualized Risk Adjusted Returns by Bucket',
    helpLabel: 'xp3qd12b',
    form: true,
    defaultParams: {
      isBasket: false,
      statistics_type: 'adjusted',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),

    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BACKTEST],
    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BASKET_ANNUALIZED_BUCKETED_RETURN,
    title: 'Annualized Returns by Bucket',
    helpLabel: 'k86qxpw13s',
    form: true,
    defaultParams: {
      isBasket: true,
      statistics_type: 'return',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),

    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET],
    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BASKET_ANNUALIZED_BUCKETED_RISK,
    title: 'Annualized Risk by Bucket',
    helpLabel: 'z26vhs99',
    form: true,
    defaultParams: {
      isBasket: true,
      statistics_type: 'risk',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),
    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET],
    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BASKET_ANNUALIZED_BUCKETED_ADJUSTED,
    title: 'Annualized Risk Adjusted Returns by Bucket',
    helpLabel: 'x63qd12b',
    form: true,
    defaultParams: {
      isBasket: true,
      statistics_type: 'adjusted',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),
    neededFiles: ['bucketed_returns_backtest'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET],
    getName,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
